import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Filters = Partial<{
  material: string;
  invoiceNumber: string;
  currentStatus: string[];
  startDate: string;
  endDate: string;
  createdAtFrom: string;
  createdAtTo: string;
}>;

type State = {
  filters: Filters;
};

type Actions = {
  updateFilters: (filters: Filters) => void;
  updateCurrentStatus: (currentStatus: string[]) => void;
  clearState: () => void;
};

type Options = {
  persisted?: boolean;
}

const getInitialState = () => ({
  filters: {},
});

const PERSISTENCE_OPTIONS = {
  name: 'service-orders-search-params-v1',
};

const store = create<State & Actions>(
  (set, get) => ({
    ...getInitialState(),
    updateFilters: (filters) => set({ filters }),
    updateCurrentStatus: (statuses) => set({
      filters: { ...get().filters, currentStatus: statuses },
    }),
    clearState: () => set(getInitialState()),
  }),
);

const persistStore = create(
  persist<State & Actions>(
    (set, get) => ({
      ...getInitialState(),
      updateFilters: (filters) => set({ filters }),
      updateCurrentStatus: (statuses) => set({
        filters: { ...get().filters, currentStatus: statuses },
      }),
      clearState: () => set(getInitialState()),
    }),
    PERSISTENCE_OPTIONS,
  ),
);

export const useServiceOrdersSearchParams = (options?: Options) => {
  return options?.persisted ? persistStore() : store();
};

